import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import RoleGuard from "@/components/RoleGuard";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import OurProgram from "@/pages/OurProgram";
import WhoWeServe from "@/pages/WhoWeServe";
import Referrals from "@/pages/Referrals";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import NotFound from "@/pages/NotFound";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminOverview from "@/pages/admin/AdminOverview";
import AdminReferrals from "@/pages/admin/AdminReferrals";
import AdminMessages from "@/pages/admin/AdminMessages";
import AdminVisitors from "@/pages/admin/AdminVisitors";
import AdminUsers from "@/pages/admin/AdminUsers";

import StaffLayout, { StaffHome } from "@/pages/staff/StaffLayout";

// Hoisted so RoleGuard's `allow` prop uses a stable array reference
const ADMIN_ONLY = ["admin"];
const STAFF_OR_ADMIN = ["employee", "admin"];

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        {/* Public marketing site */}
                        <Route element={<Layout />}>
                            <Route path="/" element={<Home />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/program" element={<OurProgram />} />
                            <Route path="/who-we-serve" element={<WhoWeServe />} />
                            <Route path="/referrals" element={<Referrals />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="/privacy" element={<Privacy />} />
                        </Route>

                        {/* Auth entry */}
                        <Route path="/admin/login" element={<AdminLogin />} />

                        {/* Admin surface (admin role only) */}
                        <Route
                            path="/admin"
                            element={
                                <ProtectedRoute>
                                    <RoleGuard allow={ADMIN_ONLY}>
                                        <AdminLayout />
                                    </RoleGuard>
                                </ProtectedRoute>
                            }
                        >
                            <Route index element={<AdminOverview />} />
                            <Route path="referrals" element={<AdminReferrals />} />
                            <Route path="messages" element={<AdminMessages />} />
                            <Route path="visitors" element={<AdminVisitors />} />
                            <Route path="users" element={<AdminUsers />} />
                        </Route>

                        {/* Staff surface (employee role — admins can also visit if they want) */}
                        <Route
                            path="/staff"
                            element={
                                <ProtectedRoute>
                                    <RoleGuard allow={STAFF_OR_ADMIN}>
                                        <StaffLayout />
                                    </RoleGuard>
                                </ProtectedRoute>
                            }
                        >
                            <Route index element={<StaffHome />} />
                        </Route>

                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </BrowserRouter>
                <Toaster position="top-right" richColors />
            </AuthProvider>
        </div>
    );
}

export default App;
